import React, { Fragment, memo } from 'react';
import { motion } from 'framer-motion';
import { Activity, ShieldCheck, Zap, Crosshair, Network, Database, Lock, Server, Cloud, Users, AlertTriangle } from 'lucide-react';
export function SignalRibbon() {
  return <div className="w-full flex flex-col items-center" data-id="element-167">
      <div className="flex items-center justify-center w-full max-w-3xl mb-8" data-id="element-168">
        <div className="flex flex-col items-center" data-id="element-169">
          <div className="w-16 h-16 rounded-full border border-picus-border bg-picus-surface flex items-center justify-center mb-3" data-id="element-170">
            <Activity className="text-picus-accent w-6 h-6" data-id="element-171" />
          </div>
          <span className="text-sm font-medium text-picus-muted uppercase tracking-widest" data-id="element-172">
            Signal
          </span>
        </div>

        <div className="flex-1 h-px bg-picus-border relative mx-4" data-id="element-173">
          <motion.div className="absolute top-0 left-0 h-full bg-gradient-to-r from-picus-blue to-picus-fuchsia" initial={{
          width: '0%'
        }} whileInView={{
          width: '100%'
        }} transition={{
          duration: 1,
          delay: 0.5
        }} data-id="element-174" />
        </div>

        <div className="flex flex-col items-center" data-id="element-175">
          <div className="w-16 h-16 rounded-full border border-picus-border bg-picus-surface flex items-center justify-center mb-3" data-id="element-176">
            <ShieldCheck className="text-picus-fuchsia w-6 h-6" data-id="element-177" />
          </div>
          <span className="text-sm font-medium text-picus-muted uppercase tracking-widest" data-id="element-178">
            Validation
          </span>
        </div>

        <div className="flex-1 h-px bg-picus-border relative mx-4" data-id="element-179">
          <motion.div className="absolute top-0 left-0 h-full bg-gradient-to-r from-picus-fuchsia to-picus-blue" initial={{
          width: '0%'
        }} whileInView={{
          width: '100%'
        }} transition={{
          duration: 1,
          delay: 1.5
        }} data-id="element-180" />
        </div>

        <div className="flex flex-col items-center" data-id="element-181">
          <div className="w-16 h-16 rounded-full border border-picus-border bg-picus-surface flex items-center justify-center mb-3" data-id="element-182">
            <Zap className="text-picus-accent w-6 h-6" data-id="element-183" />
          </div>
          <span className="text-sm font-medium text-picus-muted uppercase tracking-widest" data-id="element-184">
            Action
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full" data-id="element-185">
        {['BAS', 'Exposure Validation', 'Automated Pen Testing', 'Picus Swarm'].map((label, i) => <div key={label} className="border border-picus-border bg-picus-surface/50 p-4 text-center text-sm text-picus-text font-medium" data-id="element-186">
            {label}
          </div>)}
      </div>
    </div>;
}
export function IntegrationWall() {
  const categories = [{
    name: 'SIEM',
    icon: <Database className="w-5 h-5" data-id="element-187" />
  }, {
    name: 'EDR / XDR',
    icon: <Crosshair className="w-5 h-5" data-id="element-188" />
  }, {
    name: 'Firewalls',
    icon: <ShieldCheck className="w-5 h-5" data-id="element-189" />
  }, {
    name: 'Cloud',
    icon: <Cloud className="w-5 h-5" data-id="element-190" />
  }, {
    name: 'Identity',
    icon: <Users className="w-5 h-5" data-id="element-191" />
  }, {
    name: 'Workflow',
    icon: <Network className="w-5 h-5" data-id="element-192" />
  }];
  return <div className="relative w-full max-w-4xl mx-auto aspect-video flex items-center justify-center border border-picus-border bg-picus-surface/20 rounded-lg overflow-hidden" data-id="element-193">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at center, rgba(79, 70, 229, 0.5) 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }} data-id="element-194" />

      <div className="relative z-10 w-32 h-32 bg-picus-bg rounded-xl flex items-center justify-center" style={{
      border: '1px solid transparent',
      backgroundImage: 'linear-gradient(#050505, #050505), linear-gradient(135deg, #4F46E5, #D946EF)',
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
      boxShadow: '0 0 40px rgba(79, 70, 229, 0.2), 0 0 80px rgba(217, 70, 239, 0.1)'
    }} data-id="element-195">
        <img src="https://www.picussecurity.com/hubfs/light_logo-original-SVG.svg" alt="Picus" className="h-6" data-id="element-196" />
      </div>

      {categories.map((cat, i) => {
      const angle = i * 60 * (Math.PI / 180);
      const radius = 180;
      const x = Math.cos(angle) * radius;
      const y = Math.sin(angle) * radius;
      return <motion.div key={cat.name} initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2 + i * 0.1
      }} className="absolute flex items-center gap-3 bg-picus-surface border border-picus-border px-4 py-2 rounded-lg shadow-lg hover:border-picus-blue/30 transition-colors" style={{
        transform: `translate(${x}px, ${y}px)`
      }} data-id="element-197">
            <div className="text-picus-muted" data-id="element-198">{cat.icon}</div>
            <span className="text-sm font-medium" data-id="element-199">{cat.name}</span>
          </motion.div>;
    })}

      {/* Connecting lines SVG */}
      <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
      zIndex: 0
    }} data-id="element-200">
        {categories.map((_, i) => {
        const angle = i * 60 * (Math.PI / 180);
        const radius = 160;
        const x = Math.cos(angle) * radius;
        const y = Math.sin(angle) * radius;
        return <motion.line key={`line-${i}`} x1="50%" y1="50%" x2={`calc(50% + ${x}px)`} y2={`calc(50% + ${y}px)`} stroke="rgba(255,255,255,0.1)" strokeWidth="1" strokeDasharray="4 4" initial={{
          pathLength: 0
        }} whileInView={{
          pathLength: 1
        }} transition={{
          duration: 1,
          delay: 0.5
        }} data-id="element-201" />;
      })}
      </svg>
    </div>;
}
export function FunnelGraphic() {
  return <div className="flex flex-col items-center gap-2 w-full max-w-2xl mx-auto" data-id="element-202">
      <div className="w-full bg-picus-surface border border-picus-border p-6 text-center rounded-lg" data-id="element-203">
        <span className="text-picus-muted text-sm uppercase tracking-widest block mb-2" data-id="element-204">
          Discovered Exposure
        </span>
        <span className="text-2xl font-serif text-white" data-id="element-205">10,000+ Findings</span>
      </div>
      <div className="w-4 h-8 border-l border-picus-border" data-id="element-206" />
      <div className="w-3/4 bg-picus-surface border border-picus-blue/30 p-6 text-center rounded-lg" data-id="element-207">
        <span className="text-picus-blue text-sm uppercase tracking-widest block mb-2" data-id="element-208">
          Validated Exposure
        </span>
        <span className="text-2xl font-serif text-white" data-id="element-209">450 Exploitable</span>
      </div>
      <div className="w-4 h-8 border-l border-picus-border" data-id="element-210" />
      <div className="w-1/2 bg-picus-fuchsia/10 border border-picus-fuchsia/40 p-6 text-center rounded-lg" data-id="element-211">
        <span className="text-picus-fuchsia text-sm uppercase tracking-widest block mb-2" data-id="element-212">
          Prioritized Action
        </span>
        <span className="text-2xl font-serif text-picus-fuchsia" data-id="element-213">
          12 Critical Paths
        </span>
      </div>
    </div>;
}
export function WorkflowRibbon() {
  const nodes = ['Signal', 'Validation', 'Priority', 'Action', 'Revalidation'];
  return <div className="w-full max-w-4xl mx-auto overflow-x-auto pb-8" data-id="element-214">
      <div className="flex items-center min-w-[600px]" data-id="element-215">
        {nodes.map((node, i) => <Fragment key={node} data-id="element-216">
            <div className="flex flex-col items-center relative" data-id="element-217">
              {i % 2 !== 0 && <div className="absolute -top-8 bg-picus-surface border border-picus-border text-[10px] px-2 py-1 rounded-full text-picus-muted flex items-center gap-1" data-id="element-218">
                  <Users className="w-3 h-3" data-id="element-219" /> Human in loop
                </div>}
              <div className={`w-24 h-24 flex items-center justify-center border ${i === 3 ? 'border-picus-accent bg-picus-accent/10 text-picus-accent' : 'border-picus-border bg-picus-surface text-white'} rounded-lg rotate-45 mb-6`} data-id="element-220">
                <span className="-rotate-45 font-medium text-sm" data-id="element-221">{node}</span>
              </div>
            </div>
            {i < nodes.length - 1 && <div className="flex-1 h-px bg-picus-border mx-2 relative" data-id="element-222">
                <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 border-t border-r border-picus-border rotate-45" data-id="element-223" />
              </div>}
          </Fragment>)}
      </div>
    </div>;
}
export function AttackPathGraphic() {
  return <div className="w-full max-w-3xl mx-auto border border-picus-border bg-picus-surface/30 p-8 rounded-lg relative" data-id="element-224">
      <div className="flex justify-between items-center mb-12" data-id="element-225">
        <div className="text-center" data-id="element-226">
          <div className="w-12 h-12 bg-red-500/10 border border-red-500/30 rounded flex items-center justify-center mb-2 mx-auto" data-id="element-227">
            <AlertTriangle className="text-red-400 w-6 h-6" data-id="element-228" />
          </div>
          <span className="text-xs text-picus-muted" data-id="element-229">Initial Foothold</span>
        </div>
        <div className="flex-1 border-t border-dashed border-picus-border mx-4 relative" data-id="element-230">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-picus-bg px-2 text-xs text-picus-muted" data-id="element-231">
            Lateral Movement
          </div>
        </div>
        <div className="text-center" data-id="element-232">
          <div className="w-12 h-12 bg-picus-surface border border-picus-border rounded flex items-center justify-center mb-2 mx-auto" data-id="element-233">
            <Server className="text-picus-muted w-6 h-6" data-id="element-234" />
          </div>
          <span className="text-xs text-picus-muted" data-id="element-235">Internal Server</span>
        </div>
        <div className="flex-1 border-t border-dashed border-picus-border mx-4 relative" data-id="element-236">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-picus-bg px-2 text-xs text-picus-muted" data-id="element-237">
            Privilege Escalation
          </div>
        </div>
        <div className="text-center" data-id="element-238">
          <div className="w-12 h-12 bg-picus-accent/10 border border-picus-accent rounded flex items-center justify-center mb-2 mx-auto" data-id="element-239">
            <Database className="text-picus-accent w-6 h-6" data-id="element-240" />
          </div>
          <span className="text-xs text-picus-accent font-medium" data-id="element-241">
            Crown Jewel
          </span>
        </div>
      </div>
      <div className="bg-picus-surface border border-picus-border p-4 text-sm text-picus-muted flex items-start gap-3" data-id="element-242">
        <Lock className="w-5 h-5 text-picus-accent shrink-0" data-id="element-243" />
        <p data-id="element-244">
          Validated path: Attacker exploits CVE-2023-XXXX on external gateway,
          dumps credentials from memory, and uses valid admin token to access
          customer database.
        </p>
      </div>
    </div>;
}
export function HeatmapGraphic() {
  return <div className="w-full max-w-4xl mx-auto border border-picus-border bg-picus-surface/50 rounded-lg overflow-hidden" data-id="element-245">
      <div className="grid grid-cols-6 border-b border-picus-border bg-picus-surface text-xs font-medium text-picus-muted" data-id="element-246">
        <div className="p-3 border-r border-picus-border col-span-2" data-id="element-247">
          Control Layer
        </div>
        <div className="p-3 border-r border-picus-border text-center" data-id="element-248">
          Day 1
        </div>
        <div className="p-3 border-r border-picus-border text-center" data-id="element-249">
          Day 7
        </div>
        <div className="p-3 border-r border-picus-border text-center" data-id="element-250">
          Day 14
        </div>
        <div className="p-3 text-center" data-id="element-251">Day 30 (Tuned)</div>
      </div>
      {[{
      name: 'Network Perimeter (WAF/NGFW)',
      scores: [45, 45, 60, 92]
    }, {
      name: 'Endpoint Protection (EDR)',
      scores: [60, 75, 75, 95]
    }, {
      name: 'Email Security',
      scores: [80, 80, 85, 98]
    }, {
      name: 'Data Loss Prevention',
      scores: [30, 40, 55, 85]
    }].map((row, i) => <div key={i} className="grid grid-cols-6 border-b border-picus-border last:border-0 text-sm" data-id="element-252">
          <div className="p-4 border-r border-picus-border col-span-2 flex items-center text-picus-text" data-id="element-253">
            {row.name}
          </div>
          {row.scores.map((score, j) => <div key={j} className="p-4 border-r border-picus-border last:border-0 flex items-center justify-center" data-id="element-254">
              <div className={`w-full py-1 text-center rounded text-xs font-medium ${score < 50 ? 'bg-red-500/20 text-red-400' : score < 80 ? 'bg-yellow-500/20 text-yellow-400' : 'bg-picus-accent/20 text-picus-accent'}`} data-id="element-255">
                {score}%
              </div>
            </div>)}
        </div>)}
    </div>;
}